import Vue from 'vue'
import VueRouter from 'vue-router'
import { validateSession, userInfo } from '@/common/services/modules/auth'
import { getUserDetails } from '@/common/services'
import Store from '@/store/main.js'
import Home from '@/views/widgets/Widgets.vue'
import Orders from '@/store/modules/OrdersSearch.js'
import Cookies from 'js-cookie'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'MyClearSale',
    component: Home
  },
  {
    name: 'OidcCallBack',
    path: '/oidc-callback',
    component: () => import('@/views/OidcCallback.vue')
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: {
      isPublic: true
    }
  },
  {
    path: '/minha-conta/',
    name: 'Minha Conta',
    component: () => import('@/views/my-account/MyAccount.vue')
  },
  {
    path: '/central-notificacoes/',
    name: 'Central de Notificações',
    component: () => import('@/views/notifications/index.vue'),
    beforeEnter: (to, from, next) => {
      if (Store.getters.isNotificationSender) return next()
      return next(from.path)
    }
  },
  {
    path: '/termos/',
    name: 'Termos',
    component: () => import('@/views/terms/Terms.vue')
  },
  {
    path: '/pesquisa-de-pedidos/',
    name: 'Pesquisa de Pedidos',
    component: () => import('@/views/orders-search/OrdersSearch.vue'),
    beforeEnter: (to, from, next) => {
      if (Orders.getters.getIsRedirected) return next()
      return next(from.path)
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const isOidcCallbackURL = window.location.href.includes('/oidc-callback')

if (!isOidcCallbackURL) {
  router.beforeEach(async (to, from, next) => {
    Store.commit('HANDLE_LOADING', true)

    try {
      await validateSession()

      const State = Store.state

      let userId

      const cookie = Cookies.get('active-contract')

      userId = State?.userInfos?.sub

      if (!userId) {
        const { data: responseData } = await userInfo()
        Store.commit('UPDATE_USER_INFOS', responseData)
        userId = responseData.sub
      }

      const newCurrentEntity = cookie
        ? State.userData.entities.filter(
            entity => entity.entityLegacyId === parseInt(cookie)
          )
        : []

      if (newCurrentEntity.length > 0) {
        Store.commit('SET_USER_CURRENT_ENTITY', newCurrentEntity[0])
      } else {
        Store.commit('SET_USER_CURRENT_ENTITY', State.listEntities[0])
      }

      if (!State?.currentEntity?.usersId) {
        const {
          data,
          data: { entities }
        } = await getUserDetails({ userId })

        Store.commit('SET_USER_DETAILS', data)
        Store.commit('SET_LIST_ENTITIES', entities)
      }

      next()

      Store.commit('HANDLE_LOADING', false)
    } catch ({
      response: {
        headers: { sessid, redirecturl }
      }
    }) {
      if (sessid) localStorage.setItem('sessid', sessid)
      if (redirecturl) window.location = redirecturl
    }
  })
} else {
  Store.commit('HANDLE_LOADING', false)
}

export default router
